var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: _vm.width,
        "modal-append-to-body": _vm.modalAppendToBody,
        "close-on-click-modal": _vm.closeOnClickModal,
        "lock-scroll": _vm.lockScroll,
        "close-on-press-escape": _vm.closeOnPressEscape,
        "append-to-body": _vm.appendToBody,
        "destroy-on-close": _vm.destroyOnClose,
        "custom-class": "dialogStyle",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.close,
      },
    },
    [_vm.visible ? _vm._t("default") : _vm._e()],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/dialog.vue?vue&type=template&id=cdbdd6e2&
// module id = null
// module chunks = 